class CustomReviewCounter extends HTMLElement {
  constructor() {
    super();
    this.defaultNumber = parseInt(this.getAttribute("data-start")) || 0;
    this.delay = 30000;
    this.key = this.getAttribute("data-key");
    this.productId = this.getAttribute("data-product");
    this.start = 0;
  }

  connectedCallback() {
    this.getSetDefault();
    this.addHTML();
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), this.delay);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  updateCountdown() {
    this.start++;
    this.innerHTML = this.start;
    this.clearAndSetSessionStorage();
  }

  clearAndSetSessionStorage() {
    if (sessionStorage.getItem(this.key) !== null) {
      sessionStorage.removeItem(this.key);
    }
    sessionStorage.setItem(this.key, this.start);
  }

  getSetDefault() {
    this.start = sessionStorage.getItem(this.key) !== null ? sessionStorage.getItem(this.key) : this.defaultNumber;
  }

  addHTML() {
    this.innerHTML = `${this.start}`;
  }
}

customElements.define("custom-review-counter", CustomReviewCounter);
